import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[weightInput]'
})
export class WeightInputDirective {
    private allowedKeys: string[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];

    // Define acceptable weight range
    private minWeight = 1;    // kg
    private maxWeight = 300;  // kg

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.allowedKeys.includes(event.key)) {
            return;
        }

        // Prevent non-digit entries
        if (!/^\d$/.test(event.key)) {
            event.preventDefault();
        }
    }

    @HostListener('input', ['$event'])
    onInput(event: Event) {
        const input = event.target as HTMLInputElement;
        let value = input.value.replace(/\D+/g, '');

        // Limit to 3 digits max
        if (value.length > 3) {
            value = value.slice(0, 3);
        }

        this.renderer.setProperty(input, 'value', value);
    }

    @HostListener('blur', ['$event'])
    onBlur(event: Event) {
        const input = event.target as HTMLInputElement;
        const rawValue = input.value;

        // If the input is empty, do not enforce any min/max constraints
        if (!rawValue) {
            return;
        }

        let value = parseInt(rawValue, 10);

        // If value is not a number (unlikely due to input checks, but just in case)
        if (isNaN(value)) {
            // Clear or set a default. Here we choose to clear.
            this.renderer.setProperty(input, 'value', '');
            return;
        }

        // Clamp to min/max range
        if (value < this.minWeight) value = this.minWeight;
        if (value > this.maxWeight) value = this.maxWeight;

        this.renderer.setProperty(input, 'value', value.toString());
    }
}
